
const Privacy = () => {

// redirect to external link
window.location.href = 'https://s3-eu-west-2.amazonaws.com/kisdigital/pdf/v1/Wellbeing_Privacy_Notice.pdf'
}

export default Privacy
